<template>
  <div>
    <div v-if="signConfiguration.firma">
      <div
        class="d-flex flex-column align-items-center"
        v-if="signConfiguration.firma.activa !== 'Y'
        && signConfiguration.firma.activa !== 'P'"
      >
        <img
          class="mb-5"
          v-if="signConfiguration.estampa"
          :src="signConfiguration.estampa"
          width=400px
        >
        <br>
        <p class="message-info mb-4">Firma configurada correctamente</p>
        <small>Generando certificado</small>
      </div>
      <div
        class="d-flex flex-column align-items-center"
        v-if="signConfiguration.firma.activa === 'Y'"
      >
        <img
          class="mb-5"
          v-if="signConfiguration.estampa"
          :src="signConfiguration.estampa"
          width=400px
        >
        <br>
        <p class="message-info mb-4">Firma configurada correctamente</p>
        <small>ID Configuración: {{ signConfiguration.firma.signerUsuario }}</small>
        <small>Vencimiento: {{ signConfiguration.firma.vencimiento  | dateFormat }}</small>
        <small v-if="!signConfiguration.firma.atendida">Firma desatendida activada</small>
        <br>
        <div v-if="signConfiguration.firma.atendida && $route.name === 'user-profile'">
          <br>
          <b-button
            variant="primary"
            v-on:click="openAttendedModal"
          >
            Activar firma desatendida
          </b-button>
        </div>
        <!-- Configuración de estampa -->
        <div class="w-100 mt-4" v-if="$route.name === 'user-profile'">
          <ConfigureSignApiStamp
            prefix="asignapi"
            :user="user"
            :initialConfig="stampConfig"
          />
        </div>
      </div>
      <div
        v-else-if="signConfiguration.firma.activa === 'P' && $route.name === 'users-management'"
      >
        <h4>
          Firma pendiente de activación, el usuario debe ingresar a su perfil
          para completar el proceso de registro y enrolamiento
        </h4>
      </div>
      <CompleteActivateEnrollment
        v-else-if="signConfiguration.firma.activa === 'P' && $route.name === 'user-profile'"
        :signConfiguration="signConfiguration"
        :user="user"
        @activate="$emit('activate')"
      />
    </div>
    <div v-else>
      <div v-if="$route.name === 'user-profile'">
        <p class="message-info">
          Sin firma configurada dentro de la empresa, cont&aacute;ctese con su administrador
        </p>
      </div>
      <ActivateEnrollment
        v-else
        @signed="$emit('activate')"
        @activate="$emit('activate')"
        :user="user"
        :signConfiguration="signConfiguration"
      />
    </div>
    <b-modal
      no-close-on-backdrop
      cancel-title="Cancelar"
      hideHeaderClose
      centered
      hide-footer
      size="lg"
      ref="configModal"
      @ok="commitAction"
      @cancel="cancelProcess"
      :ok-disabled="isLoadingData"
    >
      <b-overlay :show="isLoadingData">
        <div class="container-pdf" v-if="signConfigurationData.urlResponsavilidad">
          <pdf
            class="m-auto"
            v-for="(p, index) in numPages"
            :key="`${p}-${index}`"
            :page="p"
            :src="signConfigurationData.urlResponsavilidad"
          />
        </div>
        <label>Código OTP</label>
        <b-form-input
          v-model="otp"
          id="otp_input"
          name="otp_input"
          data-vv-as="otp"
          v-validate="'required|digits:6'"
          :state="!this.errors.has('otp-form.otp_input')"
          placeholder="Ingrese los 6 dígitos enviado a su email"
        />
      </b-overlay>
      <b-button class="mt-3" block @click="closeAttendedModal">Cancelar</b-button>
      <b-button
        class="mt-3"
        variant="primary"
        block
        @click="commitAction" :disabled="isLoadingData">Confirmar</b-button>
    </b-modal>
  </div>
</template>
<script>
import { BModal } from 'bootstrap-vue';
import pdf from 'vue-pdf-signature';

import CompleteActivateEnrollment
from '@/febos/global/usuario/components/sign/advanced/aSignApi/components/CompleteActivateEnrollment';
import ActivateEnrollment from '@/febos/global/usuario/components/sign/advanced/aSignApi/components/ActivateEnrollment';
import ConfigureSignApiStamp from '@/febos/global/usuario/components/sign/advanced/aSignApi/components/ConfigureSignApiStamp';
import { configureSimpleAndEsign7Sign, getUserSign } from '@/febos/servicios/api/usuarios.api';

export default {
  name: 'AvanzadaASignAPI',
  components: {
    BModal,
    ActivateEnrollment,
    CompleteActivateEnrollment,
    ConfigureSignApiStamp,
    pdf
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object }
  },
  data: () => ({
    otp: '',
    isLoadingData: false,
    signConfigurationData: {},
    numPages: [],
    selectedFile: null
  }),
  computed: {
    stampConfig() {
      const config = this.signConfiguration || {};
      return {
        tipo: config['io.febos.asignapi.tipo'] || '2',
        plantilla: config['io.febos.asignapi.plantilla'] || '',
        imagen: config['io.febos.asignapi.imagen'] || '',
        background: config['io.febos.asignapi.background'] || '',
        representacion: config['io.febos.asignapi.representacion'] || '',
        alto: config['io.firma.asignapi.estampa.al'] || '',
        ancho: config['io.firma.asignapi.estampa.an'] || ''
      };
    }
  },
  methods: {
    async closeAttendedModal() {
      this.$refs.configModal.hide();
    },
    async openAttendedModal() {
      this.isLoadingData = true;
      this.otp = '';
      this.$refs.configModal.show();
      try {
        const { data } = await getUserSign(
          'firmaAvanzada',
          'ASignApi',
          'certificado_desatendida',
          this.user.id
        );
        this.signConfigurationData = data.parametros;
        if (this.signConfigurationData.urlResponsavilidad) {
          this.selectedFile = pdf.createLoadingTask(this.signConfigurationData.urlResponsavilidad);
          this.selectedFile.promise.then((pdfUrl) => {
            this.numPages = pdfUrl.numPages;
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoadingData = false;
      }
    },
    async commitAction() {
      this.isLoadingData = true;
      try {
        this.signConfigurationData.otp = this.otp;
        const parametros = this.signConfigurationData;
        parametros.accion = 'DESARENDIDA_CONFIRMAR';
        const data = {
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros: this.signConfigurationData,
          proveedor: 'ASignApi',
          tipoFirma: 'firmaAvanzada'
        };
        await configureSimpleAndEsign7Sign(data);
        this.$emit('activate');
        this.$bvToast.toast(
          'Se ha activado correctamente la firma desatendida',
          {
            title: 'Firma Avanzada',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoadingData = false;
      }
    },
    cancelProcess() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.message-info {
  color: white;
  width: 500px;
  font-weight: normal;
  background: #ea7037;
  border-radius: 10px 10px 10px 10px;
  padding: 10px;
}
</style>
